"use client"

import { useState } from "react"
import { useNavigate } from "react-router-dom"
import { Button, Box, Avatar } from "@mui/material"
import { useEffectAsync } from "../reactHelper"
import { useTranslation } from "../common/components/LocalizationProvider"
import PageLayout from "../common/components/PageLayout"
import SettingsMenu from "./components/SettingsMenu"
import CollectionFab from "./components/CollectionFab"
import CollectionActions from "./components/CollectionActions"
import { useDeviceReadonly, useManager } from "../common/util/permissions"
import useSettingsStyles from "./common/useSettingsStyles"
import usePersistedState from "../common/util/usePersistedState"
import DataTable from "../common/components/Datatable"
import LocalPrintshopIcon from "@mui/icons-material/LocalPrintshop"

const RevendasPage = () => {
  const classes = useSettingsStyles()
  const navigate = useNavigate()
  const t = useTranslation()

  const manager = useManager()
  const deviceReadonly = useDeviceReadonly()

  const [timestamp, setTimestamp] = useState(Date.now())
  const [items, setItems] = useState([])
  const [searchKeyword, setSearchKeyword] = useState("")
  const [showAll, setShowAll] = usePersistedState("showAllRevendas", false)
  const [loading, setLoading] = useState(false)
  const [direction, setDirection] = useState("asc")
  const [orderBy, setOrderBy] = useState("title")

  useEffectAsync(async () => {
    setLoading(true)
    try {
      const query = new URLSearchParams({ all: showAll })
      const response = await fetch(`/api/revendas?${query.toString()}`)
      if (response.ok) {
        setItems(await response.json())
      } else {
        throw Error(await response.text())
      }
    } finally {
      setLoading(false)
    }
  }, [timestamp, showAll])

  const handleExport = () => {
    window.location.assign("/api/reports/revendas/xlsx")
  }

  const getPhoto = (item) => {
    //return `./themes/${item.code}/logo.png?${Math.floor(Math.random() * 10) + 1}`
    return `/api/revendas/logo/${item.code}`
  }

  const columns = [
    { field: "id", headerName: "ID", width: 80, disableColumnMenu: true },
    {
      field: "avatar",
      headerName: "",
      width: 60,
      disableColumnMenu: true,
      sortable: false,
      renderCell: (params) => <Avatar alt={params.row.name} src={getPhoto(params.row)} />,
    },
    { field: "code", headerName: t("sharedCodeInternal"), flex: 1, disableColumnMenu: true },
    { field: "title", headerName: t("sharedName"), flex: 1, disableColumnMenu: true },
    { field: "city", headerName: t("sharedCity"), flex: 1, disableColumnMenu: true },
    { field: "state", headerName: t("sharedState"), flex: 1, disableColumnMenu: true },
    {
      field: "actions",
      headerName: t("actions"),
      sortable: false,
      renderCell: (params) => (
        <div>
          <CollectionActions
            itemId={params.row.id}
            editPath="/settings/revenda"
            endpoint="revendas"
            setTimestamp={setTimestamp}
            readonly={deviceReadonly}
          />
        </div>
      ),
      width: 150,
      disableColumnMenu: true,
    },
  ]

  return (
    <PageLayout menu={<SettingsMenu />} breadcrumbs={["userAdmin", "sharedRevendas"]}>
      {/* <SearchHeader keyword={searchKeyword} setKeyword={setSearchKeyword} />
      <Table className={classes.table}>
        <TableHead>
          <TableRow>
            <TableCell>&nbsp;</TableCell>
            <TableCell>{t('sharedCodeInternal')}</TableCell>
            <TableCell>{t('sharedName')}</TableCell>
            <TableCell>{t('sharedCity')}</TableCell>
            <TableCell>{t('sharedState')}</TableCell>
            <TableCell className={classes.columnAction} />
          </TableRow>
        </TableHead>
        <TableBody>
          {!loading ? items.filter(filterByKeyword(searchKeyword)).map((item) => (
            <TableRow key={item.id}>
              <TableCell>
                <Avatar alt={item.name} src={getPhoto(item)} />
              </TableCell>
              <TableCell>{item.code}</TableCell>
              <TableCell>{item.title}</TableCell>
              <TableCell>{item.city}</TableCell>
              <TableCell>{item.state}</TableCell>
              <TableCell className={classes.columnAction} padding="none">
                <CollectionActions
                  itemId={item.id}
                  editPath="/settings/revenda"
                  endpoint="revendas"
                  setTimestamp={setTimestamp}
                  readonly={deviceReadonly}
                />
              </TableCell>
            </TableRow>
          )) : (<TableShimmer columns={6} endAction />)}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TableCell>
              <Button onClick={handleExport} variant="text">{t('reportExport')}</Button>
            </TableCell>
            <TableCell colSpan={5} align="right">
              <FormControlLabel
                control={(
                  <Switch
                    checked={showAll}
                    onChange={(e) => setShowAll(e.target.checked)}
                    size="small"
                  />
                )}
                label={t('notificationAlways')}
                labelPlacement="start"
                disabled={!manager}
              />
            </TableCell>
          </TableRow>
        </TableFooter>
      </Table> */}
      <DataTable
        tableName="revendas"
        columns={columns}
        rows={items}
        loading={loading}
        renderBeforeTable={
          manager && (
            <Box sx={{ display: "flex", justifyContent: "flex-end", padding: "10px" }}>
              <Button variant="contained" color="primary" onClick={handleExport} startIcon={<LocalPrintshopIcon />}>
                {t("reportExport")}
              </Button>
            </Box>
          )
        }
      />
      <CollectionFab editPath="/settings/revenda" />
    </PageLayout>
  )
}

export default RevendasPage